import { SiteSection } from '../SiteSection.js';
import { Handover } from './Handover.js';

/**
 * A real reception job (§20).
 *
 * Six things, each a verb, each one a salon already pays a person to do. The
 * verb is the content, so it is set large in the page's lettering and given a
 * sentence; there is no icon beside it, because a scissors pictogram next to
 * « Réserver » says less than the word does.
 *
 * "Faire régler" is worded with care. We do not take the money and we do not
 * hold the salon's payment account: the assistant sends a payment link from
 * the salon's own Stripe (ADR-0021). Writing "nous encaissons" here would be a
 * promise the architecture deliberately does not keep.
 *
 * The sixth job, « Transférer », is then told in full underneath: when the
 * assistant hands the call over, and why that is a good outcome (`Handover`).
 */
const CAPABILITIES: readonly {
  readonly title: string;
  readonly detail: string;
}[] = [
  {
    title: 'Réserver',
    detail: 'Consulte les disponibilités réelles de votre agenda et pose le rendez-vous.',
  },
  {
    title: 'Déplacer',
    detail: 'Retrouve un rendez-vous existant et le décale, sans doublon.',
  },
  {
    title: 'Annuler',
    detail: 'Libère proprement le créneau, qui redevient disponible immédiatement.',
  },
  {
    title: 'Renseigner',
    detail: 'Horaires, adresse, tarifs, parking : les réponses que vous donneriez vous-même.',
  },
  {
    title: 'Faire régler',
    detail:
      'Envoie par SMS un lien de paiement sécurisé. L’argent arrive sur votre propre compte Stripe, sans commission. Avec Voice Pro.',
  },
  {
    title: 'Transférer',
    detail: 'Passe la main à une personne dès que la demande sort du cadre.',
  },
];

export function Capabilities(): React.JSX.Element {
  return (
    <SiteSection
      id="capacites"
      title="Un vrai travail de réception."
      intro={
        <p>
          Pas un répondeur intelligent : six tâches que votre équipe fait aujourd’hui entre deux
          clients.
        </p>
      }
    >
      <ul className="grid gap-x-10 border-b border-wall-line sm:grid-cols-2">
        {CAPABILITIES.map(({ title, detail }) => (
          <li key={title} className="border-t border-wall-line py-6">
            <h3 className="sign text-sign-sm text-ink">{title}</h3>
            <p className="mt-2 max-w-sm text-ui text-ink-muted">{detail}</p>
          </li>
        ))}
      </ul>

      <Handover />
    </SiteSection>
  );
}
